class Tool {
  // Abstract class for tools that operate on a grid. Per default, it always keeps a
  //copy of the original grid.
  constructor() {
    this.network = null;
  }
}

export default Tool;
